import ResourceLink from './resourceLink';

export class UserReadConfirmation {
  userId: string;

  linkId: number;

  version: string;

  created: Date;

  requestedVersion: string;

  readConfirmed: Date | undefined;

  lastReminder: Date | undefined;

  link: ResourceLink | undefined;

  audienceIds: number[] | undefined;

  constructor() {
    this.userId = '';
    this.linkId = 0;
    this.version = '';
    this.created = new Date();
    this.requestedVersion = '';
  }
}
